const fonts = {
	font_main_bold: 'fonts/Poppins-Bold.ttf',
	font_main_semibold: 'fonts/Poppins-SemiBold.ttf',
	font_main_regular: 'fonts/Poppins-Regular.ttf',
	heavitas_green_font:
		'assets/mobile/general_elements/custom_font/heavitas_green_font/heavitas_green_font.fnt',
	heavitas_pink_font:
		'assets/mobile/general_elements/custom_font/heavitas_pink_font/heavitas_pink_font.fnt'
};

//remove this

const symbols_bg = {
	minor_1_bg: 'assets/mobile/reel/symbols/symbol_bgs/minor_1_bg.png',
	minor_2_bg: 'assets/mobile/reel/symbols/symbol_bgs/minor_2_bg.png',
	minor_3_bg: 'assets/mobile/reel/symbols/symbol_bgs/minor_3_bg.png',
	minor_4_bg: 'assets/mobile/reel/symbols/symbol_bgs/minor_4_bg.png',
	minor_5_bg: 'assets/mobile/reel/symbols/symbol_bgs/minor_5_bg.png',
	major_1_bg: 'assets/mobile/reel/symbols/symbol_bgs/major_1_bg.png',
	major_2_bg: 'assets/mobile/reel/symbols/symbol_bgs/major_2_bg.png',
	major_3_bg: 'assets/mobile/reel/symbols/symbol_bgs/major_3_bg.png',
	major_4_bg: 'assets/mobile/reel/symbols/symbol_bgs/major_4_bg.png',
	major_5_bg: 'assets/mobile/reel/symbols/symbol_bgs/major_5_bg.png',
	wild_bg: 'assets/mobile/reel/symbols/symbol_bgs/wild_bg.png',
	scatter_bg: 'assets/mobile/reel/symbols/symbol_bgs/scatter_bg.png'
};

const symbols_blurred = {
	minor_1_blurred: 'assets/mobile/reel/symbols/isblurred/minor_1_blurred.png',
	minor_2_blurred: 'assets/mobile/reel/symbols/isblurred/minor_2_blurred.png',
	minor_3_blurred: 'assets/mobile/reel/symbols/isblurred/minor_3_blurred.png',
	minor_4_blurred: 'assets/mobile/reel/symbols/isblurred/minor_4_blurred.png',
	minor_5_blurred: 'assets/mobile/reel/symbols/isblurred/minor_5_blurred.png',
	major_1_blurred: 'assets/mobile/reel/symbols/isblurred/major_1_blurred.png',
	major_2_blurred: 'assets/mobile/reel/symbols/isblurred/major_2_blurred.png',
	major_3_blurred: 'assets/mobile/reel/symbols/isblurred/major_3_blurred.png',
	major_4_blurred: 'assets/mobile/reel/symbols/isblurred/major_4_blurred.png',
	major_5_blurred: 'assets/mobile/reel/symbols/isblurred/major_5_blurred.png',
	scatter_blurred: 'assets/mobile/reel/symbols/isblurred/scatter_blurred.png',
	wild_blurred: 'assets/mobile/reel/symbols/isblurred/wild_blurred.png'
};

const spritesheets = {
	minor_1_spritesheet:
		'assets/mobile/reel/animations/spritesheets/symbol_spritesheets/minors/minor_1_spritesheet.json',
	minor_2_spritesheet:
		'assets/mobile/reel/animations/spritesheets/symbol_spritesheets/minors/minor_2_spritesheet.json',
	minor_4_spritesheet:
		'assets/mobile/reel/animations/spritesheets/symbol_spritesheets/minors/minor_4_spritesheet.json',
	minor_3_spritesheet:
		'assets/mobile/reel/animations/spritesheets/symbol_spritesheets/minors/minor_3_spritesheet.json',
	minor_5_spritesheet:
		'assets/mobile/reel/animations/spritesheets/symbol_spritesheets/minors/minor_5_spritesheet.json',
	major_1_spritesheet_0:
		'assets/mobile/reel/animations/spritesheets/symbol_spritesheets/major/major_1_spritesheet_0.json',
	major_1_spritesheet_1:
		'assets/mobile/reel/animations/spritesheets/symbol_spritesheets/major/major_1_spritesheet_1.json',
	major_2_spritesheet:
		'assets/mobile/reel/animations/spritesheets/symbol_spritesheets/major/major_2_spritesheet.json',
	major_3_spritesheet:
		'assets/mobile/reel/animations/spritesheets/symbol_spritesheets/major/major_3_spritesheet.json',
	major_4_spritesheet:
		'assets/mobile/reel/animations/spritesheets/symbol_spritesheets/major/major_4_spritesheet.json',
	major_5_spritesheet:
		'assets/mobile/reel/animations/spritesheets/symbol_spritesheets/major/major_5_spritesheet.json',
	scatter_spritesheet:
		'assets/mobile/reel/animations/spritesheets/symbol_spritesheets/special/scatter_spritesheet.json',
	wild_spritesheet:
		'assets/mobile/reel/animations/spritesheets/symbol_spritesheets/special/wild_spritesheet.json',
	bait_blue:
		'assets/mobile/reel/animations/spritesheets/bait_spritesheets/bait_blue.json',
	payline_gold_spritesheet:
		'assets/mobile/reel/animations/spritesheets/payline_spritesheets/payline_gold_spritesheet.json',
	payline_red_spritesheet:
		'assets/mobile/reel/animations/spritesheets/payline_spritesheets/payline_red_spritesheet.json',
	bonus_special_spritesheet_1:
		'assets/mobile/bonus_round_page/bonus_special_1.json',
	bonus_special_spritesheet_2:
		'assets/mobile/bonus_round_page/bonus_special_2.json',
	bonus_special_spritesheet_3:
		'assets/mobile/bonus_round_page/bonus_special_3.json',
	bonus_reel_special_1:
		'assets/mobile/reel/animations/spritesheets/symbol_spritesheets/special/bonus_reel_special_1.json',
	featured_img_static:
		'assets/mobile/splash_screen_page/featured_img_spritesheet/featured_img_static.png',
	coin_anim:
		'assets/mobile/win_highlight_popup/coin_spritesheets/coin_anim_mobile.json',
	quest_book_small: 'assets/mobile/header_element/quest_widget/book_small.png',
	quest_book_light:
		'assets/mobile/header_element/quest_widget/quest_book_light.json',
	// reel_border_spritesheet_0:
	// 	'assets/mobile/reel/animations/spritesheets/reel_border/reel_border_spritesheet_0.json',
	// reel_border_spritesheet_1:
	// 	'assets/mobile/reel/animations/spritesheets/reel_border/reel_border_spritesheet_1.json',
	// reel_border_spritesheet_2:
	// 	'assets/mobile/reel/animations/spritesheets/reel_border/reel_border_spritesheet_2.json',
	reel_border_spritesheet_passive_0:
		'assets/mobile/reel/animations/spritesheets/reel_border_passive/reel_border_spritesheet_passive_0.json',
	reel_border_spritesheet_passive_1:
		'assets/mobile/reel/animations/spritesheets/reel_border_passive/reel_border_spritesheet_passive_1.json',
	reel_border_spritesheet_passive_2:
		'assets/mobile/reel/animations/spritesheets/reel_border_passive/reel_border_spritesheet_passive_2.json',
	reel_border_spritesheet_passive_3:
		'assets/mobile/reel/animations/spritesheets/reel_border_passive/reel_border_spritesheet_passive_3.json',
	bonus_buy_border_passive_spritesheet:
		'assets/mobile/bonus_buy_widget/spritesheets/bonus_buy_border_passive.json',
	bonus_total_win_border_0:
		'assets/mobile/bonus_round_page/bonus_total_win_border_0.json',
	bonus_total_win_border_1:
		'assets/mobile/bonus_round_page/bonus_total_win_border_1.json',
	astronaut_in: 'assets/mobile/bonus_round_page/astronaut_in_spritesheet.json',
	astronaut_out: 'assets/mobile/bonus_round_page/astronaut_out_spritesheet.json'
};

const masks = {
	reel_wild_light:
		'assets/mobile/reel/animations/spritesheets/symbol_spritesheets/special/wild_light.png',
	reel_wild_text_mask:
		'assets/mobile/reel/animations/spritesheets/symbol_spritesheets/special/wild_text_mask.png',
	reel_wild_text_x2_mask:
		'assets/mobile/reel/animations/spritesheets/symbol_spritesheets/special/wild_text_x2_mask.png',
	reel_wild_text_x3_mask:
		'assets/mobile/reel/animations/spritesheets/symbol_spritesheets/special/wild_text_x3_mask.png',
	reel_wild_text_x4_mask:
		'assets/mobile/reel/animations/spritesheets/symbol_spritesheets/special/wild_text_x4_mask.png',
	reel_wild_text_x5_mask:
		'assets/mobile/reel/animations/spritesheets/symbol_spritesheets/special/wild_text_x5_mask.png',
	reel_scatter_text_mask:
		'assets/mobile/reel/animations/spritesheets/symbol_spritesheets/special/scatter_text_mask.png'
};

const bonusGame = {
	bonus_progress_item_2:
		'assets/mobile/bonus_round_page/bonus_progress_item_2.png',
	bonus_progress_item_1:
		'assets/mobile/bonus_round_page/bonus_progress_item_1.png',
	bonus_trigger: 'assets/desktop/bonus_round_page/bonus_trigger.png',
	bonus_total_win_bg: 'assets/mobile/bonus_round_page/bonus_total_win_bg.png',
	bonus_astronaut: 'assets/mobile/bonus_round_page/bonus_astronaut.png'
};

const symbol_texts = {
	reel_wild_text:
		'assets/mobile/reel/animations/spritesheets/symbol_spritesheets/special/wild_text.png',
	reel_wild_text_x2:
		'assets/mobile/reel/animations/spritesheets/symbol_spritesheets/special/wild_text_x2.png',
	reel_wild_text_x3:
		'assets/mobile/reel/animations/spritesheets/symbol_spritesheets/special/wild_text_x3.png',
	reel_wild_text_x4:
		'assets/mobile/reel/animations/spritesheets/symbol_spritesheets/special/wild_text_x4.png',
	reel_wild_text_x5:
		'assets/mobile/reel/animations/spritesheets/symbol_spritesheets/special/wild_text_x5.png',
	reel_scatter_text:
		'assets/mobile/reel/animations/spritesheets/symbol_spritesheets/special/scatter_text.png'
};

const reel = {
	reel_divider: 'assets/mobile/reel/elements/reel_divider.png',
	reel_bg: 'assets/mobile/reel/elements/reel_bg.png',
	cometPng: 'assets/desktop/reel/elements/comet.png',
	star: 'assets/desktop/reel/elements/star.png',
	coeffs_left_bg: 'assets/desktop/reel/elements/coeffs_left_bg.png',
	coeffs_right_bg: 'assets/desktop/reel/elements/coeffs_right_bg.png'
};

const dialogue = {
	dialog_main_bg: 'assets/mobile/dialog_element/dialog_main_bg.png',
	fastspin_dialogue_bg: 'assets/mobile/dialog_element/fastspin_dialogue_bg.png',
	dialog_no_btn: 'assets/desktop/dialog_element/dialog_no_btn.png',
	dialog_yes_btn: 'assets/desktop/dialog_element/dialog_yes_btn.png'
};

const btn_elements = {
	//SWITCHERS
	switcher_back_off: 'assets/desktop/general_elements/switcher_back_off.png',
	switcher_btn_off: 'assets/desktop/general_elements/switcher_btn_off.png',
	switcher_back_on: 'assets/desktop/general_elements/switcher_back_on.png',
	switcher_btn_on: 'assets/desktop/general_elements/switcher_btn_on.png',
	//CHECKBOX
	checkbox_active: 'assets/desktop/general_elements/checkbox_active.png',
	checkbox_inactive: 'assets/desktop/general_elements/checkbox_inactive.png',
	//BET
	increase_bet_icon:
		'assets/desktop/action_buttons_elements/increase_bet_icon.png',
	decrease_bet_icon:
		'assets/desktop/action_buttons_elements/decrease_bet_icon.png',
	//SPIN
	spin_btn: 'assets/desktop/action_buttons_elements/spin_btn.png',
	spin_btn_lowered:
		'assets/desktop/action_buttons_elements/spin_btn_lowered.png',

	//STOP
	stop_btn: 'assets/desktop/action_buttons_elements/stop_btn.png',
	stop_btn_lowered:
		'assets/desktop/action_buttons_elements/stop_btn_lowered.png',
	//auto/fast

	blue_btn_lowered:
		'assets/desktop/action_buttons_elements/btn_sm_blue_lowered.png',
	btn_blue: 'assets/desktop/action_buttons_elements/btn_sm_blue.png',
	red_btn_lowered: 'assets/desktop/action_buttons_elements/btn_sm_red.png',

	bet_amount_bg: 'assets/desktop/action_buttons_elements/bet_amount_bg.png',
	infinite_icon: 'assets/desktop/action_buttons_elements/infinite.png'
};

const icons = {
	stop_icon: 'assets/desktop/action_buttons_elements/icons/stop_icon.png', //spinButtonsView
	spin_icon: 'assets/desktop/action_buttons_elements/icons/spin_icon.png', //spinButtonsView
	auto_icon_red:
		'assets/desktop/action_buttons_elements/icons/auto_icon_red.png', //spinButtonsView
	auto_icon_blue:
		'assets/desktop/action_buttons_elements/icons/auto_icon_blue.png', //spinButtonsView
	fast_icon_blue:
		'assets/desktop/action_buttons_elements/icons/fast_icon_blue.png', //spinButtonsView
	fast_icon_red:
		'assets/desktop/action_buttons_elements/icons/fast_icon_red.png' //spinButtonsView
};

const auto_modal = {
	auto_modal_btn: 'assets/desktop/autospin_modal/auto_modal_btn.png',
	autospin_bg: 'assets/mobile/autospin_modal/autospin_bg.png',
	infinity_symbol_activated:
		'assets/desktop/autospin_modal/infinity_symbol_activated.png',
	infinity_symbol: 'assets/desktop/autospin_modal/infinity_symbol.png',
	selected_amount_bg: 'assets/desktop/autospin_modal/selected_amount_bg.png',
	unselected_amount_bg: 'assets/desktop/autospin_modal/unselected_amount_bg.png'
};

const external_bonus = {
	external_bonus_bg: 'assets/mobile/external_bonus/external_bonus_bg.png',
	external_bonus_play_later_btn:
		'assets/desktop/external_bonus/external_bonus_play_later_btn.png',
	external_bonus_play_now_btn:
		'assets/desktop/external_bonus/external_bonus_play_now_btn.png',
	time_frame: 'assets/desktop/external_bonus/time_frame.png',
	bonus_reel_indicator: 'assets/mobile/external_bonus/bonus_reel_indicator.png'
};

const settings_page = {
	settings_page_item_bg_off:
		'assets/desktop/settings_page/settings_page_item_bg_off.png',
	settings_page_item_bg_on:
		'assets/desktop/settings_page/settings_page_item_bg_on.png',
	settings_page_main_bg: 'assets/mobile/settings_page/settings_page_main_bg.png'
};

const header_info = {
	header_info_icon: 'assets/desktop/header_element/header_info_icon.png',
	header_sound_on: 'assets/desktop/header_element/header_sound_on.png',
	header_sound_off: 'assets/desktop/header_element/header_sound_off.png',
	header_settings_icon: 'assets/desktop/header_element/header_settings_icon.png'
};

const widgets = {
	bonus_buy_widget_bg:
		'assets/desktop/bonus_buy_widget/bonus_buy_widget_bg.png',
	bonus_img: 'assets/mobile/bonus_buy_widget/bonus_img.png',
	bonus_buy_widget_bg_hovered:
		'assets/desktop/bonus_buy_widget/bonus_buy_widget_bg_hovered.png',
	quest_widget_bg:
		'assets/desktop/header_element/quest_widget/quest_widget_bg.png',
	quest_widget_bg_hovered:
		'assets/desktop/header_element/quest_widget/quest_widget_bg_hovered.png',
	double_chance_widget_bg:
		'assets/desktop/double_bonus_chance_widget/double_chance_widget_bg.png',
	double_chance_widget_bg_hovered:
		'assets/desktop/double_bonus_chance_widget/double_chance_widget_bg_hovered.png',
	double_chance_widget_bg_mobile:
		'assets/desktop/double_bonus_chance_widget/double_chance_widget_bg_mobile.png',
	double_chance_widget_bg_mobile_hovered:
		'assets/desktop/double_bonus_chance_widget/double_chance_widget_bg_mobile_hovered.png',
	double_chance_switcher_icon_on:
		'assets/desktop/double_bonus_chance_widget/double_chance_switcher_icon_on.png',
	double_chance_switcher_icon_off:
		'assets/desktop/double_bonus_chance_widget/double_chance_switcher_icon_off.png',
	double_chance_switcher_bg_on:
		'assets/desktop/double_bonus_chance_widget/double_chance_switcher_bg_on.png',
	double_chance_switcher_bg_off:
		'assets/desktop/double_bonus_chance_widget/double_chance_switcher_bg_off.png'
};

const general_elements = {
	cosmo_logo: 'assets/mobile/header_element/cosmo-logo.png',
	volatility: 'assets/desktop/splash_screen_page/volatility.png',
	play_now_btn: 'assets/desktop/splash_screen_page/play_now_btn.png',
	play_icon_blue: 'assets/desktop/splash_screen_page/play_icon_blue.png',
	pagination_bullet_active:
		'assets/desktop/general_elements/pagination_bullet_active.png',
	pagination_bullet_inactive:
		'assets/desktop/general_elements/pagination_bullet_inactive.png',
	pagination_arrow_left:
		'assets/desktop/general_elements/pagination_arrow_left.png',
	pagination_arrow_right:
		'assets/desktop/general_elements/pagination_arrow_right.png',
	close_icon_hovered: 'assets/desktop/general_elements/close_icon_hovered.png',
	close_icon: 'assets/desktop/general_elements/close_icon.png',
	comet: 'assets/desktop/general_elements/comet.png',
	status_bar_mobile: 'assets/mobile/status_bar_element/status_bar_mobile.png',
	congrats_screen: 'assets/mobile/general_elements/congrats_screen.png',
	modal_bg: 'assets/mobile/general_elements/mobile_modal_bgs.png'
};

const quest_items = {
	quest_ten: 'assets/desktop/quest_page/quest_ten.png',
	quest_j: 'assets/desktop/quest_page/quest_j.png',
	quest_q: 'assets/desktop/quest_page/quest_q.png',
	quest_k: 'assets/desktop/quest_page/quest_k.png',
	quest_ace: 'assets/desktop/quest_page/quest_ace.png',
	quest_telescope: 'assets/desktop/quest_page/quest_telescope.png',
	quest_helmet: 'assets/desktop/quest_page/quest_helmet.png',
	quest_asteroid: 'assets/desktop/quest_page/quest_asteroid.png',
	quets_starship: 'assets/desktop/quest_page/quest_starship.png',
	quest_alien: 'assets/desktop/quest_page/quest_alien.png'
};

const quest_page = {
	quest_activate_btn: 'assets/desktop/quest_page/quest_activate_btn.png',
	quest_bg_mobile: 'assets/desktop/quest_page/quest_bg_mobile.png',

	quest_reward_icon_1: 'assets/desktop/quest_page/quest_reward_icon_1.png',
	quest_reward_icon_2: 'assets/desktop/quest_page/quest_reward_icon_2.png',
	quest_reward_icon_3: 'assets/desktop/quest_page/quest_reward_icon_3.png',
	quest_reward_icon_4: 'assets/desktop/quest_page/quest_reward_icon_4.png',
	quest_reward_icon_5: 'assets/desktop/quest_page/quest_reward_icon_5.png',

	quest_item_icon_1: 'assets/desktop/quest_page/quest_item_icon_1.png',
	quest_item_icon_2: 'assets/desktop/quest_page/quest_item_icon_2.png',
	quest_item_icon_3: 'assets/desktop/quest_page/quest_item_icon_3.png',
	quest_item_icon_4: 'assets/desktop/quest_page/quest_item_icon_4.png',

	trophy_icon: 'assets/desktop/quest_page/trophy_icon.png',
	clock_icon: 'assets/desktop/quest_page/clock_icon.png',

	quest_activated_btn: 'assets/desktop/quest_page/quest_activated_btn.png',

	quest_reward_item_bg: 'assets/mobile/quest_page/quest_reward_item_bg.png',
	claim_btn_lowered: 'assets/desktop/quest_page/claim_btn_lowered.png',
	quest_featured_img: 'assets/mobile/quest_page/quest_featured_img.png',

	quest_checked_btn: 'assets/desktop/quest_page/quest_checked_btn.png',
	quest_item_bg: 'assets/desktop/quest_page/quest_item_bg.png',
	claim_btn: 'assets/desktop/quest_page/claim_btn.png'
};
const notif_component = {
	error_content_bg: 'assets/mobile/notif_element/error_content_bg.png',
	notif_bg: 'assets/mobile/notif_element/notif_bg.png',
	notif_btn: 'assets/desktop/notif_element/notif_btn.png'
};

const winHighlight = {
	//WIN HIGHLIGHT
	title_cosmicwin: 'assets/mobile/win_highlight_popup/title_cosmicwin.png',
	title_megawin: 'assets/mobile/win_highlight_popup/title_megawin.png',
	title_nicewin: 'assets/mobile/win_highlight_popup/title_nicewin.png',
	title_superwin: 'assets/mobile/win_highlight_popup/title_superwin.png',
	core: 'assets/mobile/win_highlight_popup/core.png',
	wing_right: 'assets/mobile/win_highlight_popup/wing_right.png',
	wing_left: 'assets/mobile/win_highlight_popup/wing_left.png'
};

const splash = {
	splash_bg: 'assets/mobile/splash_screen_page/splash_bg.png',
	is_blurred_bg: 'assets/mobile/splash_screen_page/is_blurred_bg.png',
	splash_quest_bg_blured:
		'assets/mobile/splash_screen_page/splash_quest_bg_blured.png',
	splash_quest_book: 'assets/mobile/splash_screen_page/splash_quest_book.png'
};
export const assetListMobile = {
	...fonts,
	...symbols_bg,
	...symbols_blurred,
	...spritesheets,
	...masks,
	...symbol_texts,
	...reel,
	...btn_elements,
	...icons,
	...bonusGame,
	...auto_modal,
	...dialogue,
	...external_bonus,
	...settings_page,
	...header_info,
	...widgets,
	...quest_items,
	...general_elements,
	...notif_component,
	...winHighlight,
	...splash,
	...quest_page
};
